















import { DisplayShopListItem } from './../../product-source/types';
import { defineComponent, PropType } from '@vue/composition-api';
import backupImg from '@/components/common/back-img/index.vue';

const name = 'ttam-product-source-shop-prefix';
export default defineComponent({
  name,
  components: {
    backupImg,
  },
  props: {
    shop: {
      type: Object as PropType<DisplayShopListItem>,
      default: () => ({}),
    },
  },
  setup() {
    return {
      name,
    };
  },
});
